/**
 * Created by coolguy on 2017/8/13.
 */
import React from 'react';
import {Table,Switch,Button} from 'antd';
import Add from '../ContactList/Add';
import {connect} from 'react-redux';
import actions from '../../actions/index.js';

class ContactTable extends React.Component{
    state = {
        visible:false
    };

    columns = [{
        title:'操作',
        //必须指定dataIndex===id的项，否则会有warning
        dataIndex:'id',
        render:(id,record)=>{
            return <a  onClick={this.chooseContact.bind(this, record)}>选择</a>;
        }
    },{
        title: '姓名',
        dataIndex: 'name',
    },window.actionFor('order-info-contact', 'boolean') ? null : {
        title: '手机号',
        dataIndex: 'mobile',
    },{
        title:'关键决策人',
        dataIndex:'important',
        render:(important)=>{
            return !!(important*1) ? '是' : '否';
        }
    }].filter(it=>!!it);

    chooseContact = (record)=>{
        this.props.onChange({
            contactname:record.name,
            contactphone:record.mobile
        });

        this.setState({
            visible:false
        });
    }

    showAddContact=()=>{
        let {dispatch} = this.props;
        dispatch(actions.showAddCommon(true));
    };

    afterAddContact(dt) {
        var data = [].concat(this.props.data || []);
        data.push(dt);
        this.props.onChange(data);
    }

    render(){
        let {value} = this.props;

        return (
            <div className="product-table">
                <p>{value ? (value.contactname||"") + ' ' + (window.actionFor('order-info-contact', 'boolean') ? '' : (value.contactphone||"")) : ""} <a onClick={()=>this.setState({visible:!this.state.visible})} >{this.state.visible ? '关闭联系人列表' : '从联系人列表选择'}</a></p>
                {this.state.visible ? <div style={{marginTop:10}}>
                    <Table
                        size="small"
                        columns={this.columns}
                        dataSource={this.props.data||[]}
                        pagination={false}
                        rowKey="id"
                    />
                    <div><Button {...window.actionFor('contact-create')} type={"primary"} style={{marginTop:10}} onClick={this.showAddContact}>添加联系人</Button></div>
                    <Add addCallback={this.afterAddContact.bind(this)} consumerid={this.props.consumerid} consumer={this.props.consumer} />
                </div> : null}
            </div>
        )
    }
}

export default connect()(ContactTable);



// WEBPACK FOOTER //
// ./src/components/Select/ContactTable.js